import { render, staticRenderFns } from "./loan-transaction-summary-v3.vue?vue&type=template&id=4aa6700e&scoped=true&"
import script from "./loan-transaction-summary-v3.vue?vue&type=script&lang=js&"
export * from "./loan-transaction-summary-v3.vue?vue&type=script&lang=js&"
import style0 from "./loan-transaction-summary-v3.vue?vue&type=style&index=0&id=4aa6700e&scoped=true&lang=css&"
import style1 from "./loan-transaction-summary-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa6700e",
  null
  
)

export default component.exports